import {IWindowService} from '../services/window/window.service.interface';
import {IStorageService} from "../services/storage/storage.service.interface";
import {getMiniOrbitName} from '../services/mini-orbit/mini-orbit-consts';
import {IThemeDefinition} from "../services/theme/theme-definition.interface";
import {IAssetsMap} from "./assets/assets-map.interface";
import {IThemeInitializationParams} from "./architecture/theme-initialization-params";





function getThemeName(themeName: string, windowService: IWindowService, storageService: IStorageService): string {

    const miniOrbitName = getMiniOrbitName(storageService)

    if(miniOrbitName) {
        return `${themeName}/${miniOrbitName}`.toLowerCase();
    }
    return themeName;
}

export async function  selectTheme(options: {
                                themeName: string;
                                assetsMap: IAssetsMap,
                                serverPath: string;
                                skinFullName: string;
                                window: IWindowService;
                                storage: IStorageService;
                            }): Promise<IThemeDefinition> {

    const themeName = getThemeName(options.themeName, options.window, options.storage);
    const themeDefinitionModule = await import(/* webpackChunkName: "theme-definition" */ `./definitions/${themeName}/theme.definition`)

    const themeInitParams: IThemeInitializationParams = {
        assetsMap: options.assetsMap
    };

    return themeDefinitionModule.default(themeInitParams);
}


